import {  useDispatch, useSelector } from "react-redux"
import { Field, Input, Label, TextArea } from "../../styles/common"
import { ComponentUpdate } from "../../store/slices/component"
import { useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import { GetCategories } from "../../common/CommonApi";
import styled from "styled-components";
import { ImagePlus, Trash2, X } from "lucide-react";
import {
  CloseButton,
  HelperText,
  ImagePreview,
  ImageUploadBox,
  PrimaryButton,
  SecondaryButton,
  SetupBody,
  SetupDialog,
  SetupFooter,
  SetupHeader,
  SetupOverlay
} from "./ProductSetupModal";

export const AddBrand = () => {
    const [brandImage, setBrandImage] = useState(null);
    const [brandAuthorizationDocument, setBrandAuthorizationDocument] = useState(null);
    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch()
    const [form, setForm] = useState({
        brandName: '',
        brandDescription: '',
      });
    const previewUrl = useMemo(() => brandImage ? URL.createObjectURL(brandImage) : "", [brandImage]);
    const authorizationPreviewUrl = useMemo(
      () => brandAuthorizationDocument ? URL.createObjectURL(brandAuthorizationDocument) : "",
      [brandAuthorizationDocument]
    );

    useEffect(() => {
      return () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        if (authorizationPreviewUrl) URL.revokeObjectURL(authorizationPreviewUrl);
      };
    }, [previewUrl, authorizationPreviewUrl]);

    const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBrandImage(file);
    }
  };

  const removeImage = () => {
    setBrandImage(null);
  };

  const handleAuthorizationChange = (e) => {
    const file = e.target.files[0];
    if (file) setBrandAuthorizationDocument(file);
  };

  const removeAuthorizationDocument = () => setBrandAuthorizationDocument(null);

  
    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!form.brandName.trim() || selectedCategories.length === 0 || !brandImage || !brandAuthorizationDocument) {
        Swal.fire("Missing required information", "Brand name, main category, brand logo, and trademark authorization image are required.", "error");
        return;
      }

      const formData = new FormData();
      formData.append("user_id", auth._id);
      formData.append("brandName", form.brandName);
      formData.append("brandDescription", form.brandDescription);
      formData.append("category", JSON.stringify(selectedCategories));
      if (brandImage) {
        formData.append("brandImage", brandImage);
      }
      formData.append("brandAuthorizationDocument", brandAuthorizationDocument);
      try {
        const response = await fetch(process.env.REACT_APP_API_URL + "brands", {
            method: "POST",
            body: formData,
          });
          const data = await response.json();
          if (data.message === "SUCCESS_FULLY_CREATED") {
            Swal.fire({
              icon: "success",
              title: "Brand submitted for approval",
              text: "Your brand will be reviewed by the administrator and approved within 24 hours.",
              confirmButtonText: "OK",
            });
              dispatch(ComponentUpdate({
                isBrandAddOpen: false
              }))
          }
          // console.log("Success:", data);
  
  
      } catch (err) {
        console.error("Error:", err);
      }
    };

      const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setForm((prevForm) => ({
        ...prevForm,
        [name]:
            type === "checkbox"
            ? checked
            : type === "file"
                ? files[0]   // 👈 will store in form.categoryImage
                : name === "sortOrder"
                ? Number(value)
                : value,
        }));
    };

  useEffect(()=>{
    fetchData()
  },[])
  const fetchData = async () => {
    const categoriesResponse = await GetCategories();
    setCategories(categoriesResponse.data.data);
  }


const handleCategoryChange = (id) => {
  setSelectedCategories((current) =>
    current.includes(id)
      ? current.filter((categoryId) => categoryId !== id)
      : [...current, id]
  );
};
const closeModal = () => dispatch(ComponentUpdate({isBrandAddOpen:false}));

    return (
        <SetupOverlay onClick={closeModal}>
            <SetupDialog width="560px" onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
                <SetupHeader>
                    <div>
                      <h2>Add Brand</h2>
                      <p>Create a brand profile and connect it with the categories where it should appear.</p>
                    </div>
                    <CloseButton type="button" aria-label="Close add brand" onClick={closeModal}>
                      <X size={18} />
                    </CloseButton>
                </SetupHeader>
                <SetupBody>
                <Field>
                    <Label>Brand Name</Label>
                    <Input name="brandName"
                    value={form.brandName} 
                    onChange={handleChange} 
                    required
                    />
                </Field>
                {/* <Field>
                    <Label>Main Category</Label>
                    <Dropdown
                        name="category"
                        onChange={handleProduct}
                    >
                        {
                            categories.map((data) => {
                                return (<Item value={data._id}>{data.categoryName}</Item>)
                            })
                        }
                    </Dropdown>
                </Field> */}
                <Field>
                  <Label>Main Category *</Label>
                  <CategoryOptions>
                    {categories.map((category) => (
                      <CategoryOption key={category._id}>
                        <input
                          type="checkbox"
                          checked={selectedCategories.includes(category._id)}
                          onChange={() => handleCategoryChange(category._id)}
                        />
                        {category.categoryName}
                      </CategoryOption>
                    ))}
                  </CategoryOptions>
                  <HelperText>Select at least one main category.</HelperText>
                </Field>
                <Field>
                    <Label>Brand Description</Label>
                    <TextArea name="brandDescription"
                    value={form.brandDescription} 
                    onChange={handleChange} 
                    />
                </Field>
                <Field>
                <Label>Brand Logo *</Label>

                {!brandImage ? (
                    <ImageUploadBox>
                      <ImagePlus size={22} />
                      Upload brand logo
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        required
                      />
                    </ImageUploadBox>
                ) : (
                    <ImagePreview>
                    <img
                        src={previewUrl}
                        alt="brand-preview"
                    />
                    <div>
                        <PreviewTitle>{brandImage.name}</PreviewTitle>
                        <PreviewMeta>{Math.ceil(brandImage.size / 1024)} KB</PreviewMeta>
                        <RemoveImageButton
                        type="button"
                        onClick={removeImage}
                        >
                          <Trash2 size={14} />
                          Delete
                        </RemoveImageButton>
                    </div>
                    </ImagePreview>
                )}
                </Field>
                <Field>
                <Label>Brand Authorization / Trademark Licence *</Label>

                {!brandAuthorizationDocument ? (
                    <ImageUploadBox>
                      <ImagePlus size={22} />
                      Upload authorization image
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleAuthorizationChange}
                        required
                      />
                    </ImageUploadBox>
                ) : (
                    <ImagePreview>
                    <img
                        src={authorizationPreviewUrl}
                        alt="brand-authorization-preview"
                    />
                    <div>
                        <PreviewTitle>{brandAuthorizationDocument.name}</PreviewTitle>
                        <PreviewMeta>{Math.ceil(brandAuthorizationDocument.size / 1024)} KB</PreviewMeta>
                        <RemoveImageButton
                        type="button"
                        onClick={removeAuthorizationDocument}
                        >
                          <Trash2 size={14} />
                          Delete
                        </RemoveImageButton>
                    </div>
                    </ImagePreview>
                )}
                </Field>
                </SetupBody>
                <SetupFooter>
                  <SecondaryButton type="button" onClick={closeModal}>Cancel</SecondaryButton>
                  <PrimaryButton type="submit">Add Brand</PrimaryButton>
                </SetupFooter>
            </SetupDialog>
        </SetupOverlay>
    )
}

const CategoryOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 10px;
  margin-top: 8px;
`;

const CategoryOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #334155;
  cursor: pointer;
  font-size: 13px;

  input {
    width: 16px;
    height: 16px;
    accent-color: #0f766e;
  }
`;

const PreviewTitle = styled.div`
  max-width: 340px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const PreviewMeta = styled.div`
  margin: 4px 0 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
`;

const RemoveImageButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #fecaca;
  border-radius: 8px;
  background: #fff;
  color: #dc2626;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;

  &:hover {
    background: #fef2f2;
  }
`;
